import { locateEnclosingElement } from '../defs';
import { getCookieConsentAppInstance } from './cookie-consent';
import Cookie from 'js-cookie';

const wannaChatCookieKey = 'sugenattchattamedoss';

export default function initChat() {
    const cookieConsent = getCookieConsentAppInstance();
    const wannaChat = !!Cookie.get(wannaChatCookieKey) || window.location.hash === '#open-chat';

    if (wannaChat && isMarketingCookieAccepted()) {
        Cookie.remove(wannaChatCookieKey);
        openChat();
    }

    document.body.addEventListener('click', event => {
        const anchor = locateEnclosingElement(event.target, 'a');
        if (anchor && anchor.getAttribute('href').match(/#open-chat[?]?/)) {
            event.preventDefault();
            openChat();
        }
    }, { capture: true });

    function isMarketingCookieAccepted() {
        const acceptedTypes = cookieConsent.acceptedCookieTypes || [];
        return acceptedTypes.findIndex(type => type.name === 'marketing') >= 0;
    }

    function openChat() {

        if (!isMarketingCookieAccepted()) {
            requireCookie();
        } else {
            doOpenChat();
        }

        function requireCookie() {
            Cookie.set(wannaChatCookieKey, '1', {
                expires: (new Date()).getTime() + 3600000,
                path: '/',
            });
            cookieConsent.openWithMessage('Om du vill chatta med oss behöver du godkänna marknadsföringscookies nedan');
        }

        function doOpenChat() {
            getChatButton().then(button => button.click()).catch(console.log);
        }

        async function getChatButton() {
            return new Promise((resolve, reject) => {
                const widgetContainer = document.getElementById('quriobotWidgetContainer');
                if (widgetContainer && widgetContainer.classList.contains('show')) {
                    reject('Chat already open');
                }
                let intval = setInterval(() => {
                    const popupButton = document.getElementById('quriobotPopupButton');
                    if (popupButton) {
                        window.clearInterval(intval);
                        resolve(popupButton);
                    }
                }, 100);
            });
        }
    }
}
